export const programs = [
  {
    number: '01',
    title: 'C.A.M.P.',
    subtitle: 'Career and Mentorship Preparation',
    description: 'A practical workforce-readiness experience introducing young adults to expectations, teamwork, service, and responsibility in restaurant and food-industry environments.',
    outcomes: ['Workplace expectations', 'Communication and teamwork', 'Food-service fundamentals', 'Career confidence']
  },
  {
    number: '02',
    title: 'Life Skills',
    subtitle: 'Everyday tools for independence',
    description: 'Hands-on learning that helps young people make informed decisions, communicate effectively, manage responsibilities, and confidently navigate adult life.',
    outcomes: ['Personal responsibility', 'Practical decision-making', 'Healthy communication', 'Goal setting']
  },
  {
    number: '03',
    title: 'Community Outreach',
    subtitle: 'Learning through service',
    description: 'Youth join family-focused community events and volunteer alongside local organizations, building relationships while making a visible contribution.',
    outcomes: ['Public service', 'Community connection', 'Leadership practice', 'Positive role models']
  }
];

export const sponsors = [
  'The Home Depot',
  "Jared's",
  'Frito-Lay',
  'Jack in the Box'
];

export const impactPoints = [
  {
    value: '501(c)(3)',
    label: 'Community nonprofit'
  },
  {
    value: 'PNW',
    label: 'Regional focus'
  },
  {
    value: '3',
    label: 'Program pathways'
  },
  {
    value: '1',
    label: 'Stronger community'
  }
];